<template>
  <div>
    <b-container fluid class="pb-5 card-management">
        <b-row>
          <b-col xl="12" class="mb-2">
            <h3 class="pl-3 pt-3">{{ $t('Card Management') }}</h3>
            <div class=" mb-4">
              <div class="row">
                <div class="col-12">
                  <step-container 
                    :current_step="2" 
                    :skip_last="!haveFee"
                    :step_list="stepList"
                  ></step-container>
                </div>                
              </div>

              <b-row>
                <b-col xl="8" class="mb-5">
                  <div class="block-item p-3 mb-4">
                    <h3>{{ $t('Information') }}</h3>
                    <div class="form-group mb-0 mt-3 p-3">
                      <b-row>
                        <b-col sm="12" md="6">
                          <label>{{ $t('Embossed Name') }} <span class="text-danger">*</span></label>
                          <input type="text" v-model="embossed_name" class="form-control" @change="onChange('embossed_name')" @keydown="EmbossedNameCondition" onpaste="return false;" maxlength="20" autocomplete=off v-uppercase
                          :placeholder="$t('Name on your card')" :class="isDisabled?'disabled':''" :disabled="isDisabled"/>
                          <div v-if="error.embossed_name" class="invalid-feedback d-block">
                              {{$t(error.embossed_name)}}
                          </div>
                        </b-col>
                        <b-col sm="12" md="6">
                          <label>{{ $t('Currency') }} <span class="text-danger">*</span></label>
                          <select name="currency" v-model="currency" class="form-control" @change="onChange('currency')">
                            <option value="">-- {{ $t('Select Currency') }} --</option>
                            <option value="HKD">HKD</option>
                            <option value="USD">USD</option>
                          </select>
                          <div v-if="error.currency" class="invalid-feedback d-block">
                              {{$t(error.currency)}}
                          </div>
                        </b-col>
                      </b-row>
                    </div>
                  </div>
                  <div v-if="data && data.arrival_duration>0" class="block-item p-3 mb-4">
                    <h3>{{ $t('Delivery Address') }}</h3>
                    <delivery-address ref="delivery-address" @selected-country="setStep"></delivery-address>
                  </div>
                  <b-row class="d-flex mx-1">
                    
                    <button @click="$router.push({ name: 'card-management'});" class="btn btn-previous d-block mr-auto">{{ $t('Previous') }}</button>
                    <button @click="nextStep()" class="btn bg-upload-payment d-block">{{ $t('Next') }}</button>
                  </b-row>
                </b-col>
                <b-col xl="4">
                  <choosen-card :data="data" :ref="'choosenCard'"></choosen-card>
                </b-col>
              </b-row>
            </div>
          </b-col>
        </b-row>
    </b-container>

    <b-modal id="complete-card-management" title="CompleteMessage" @hide="onHideModal">
      <template #modal-title>
        {{ $t('Completed Message') }}
      </template>
      <b-row class="d-flex justify-content-center complete-card">
        <b-col sm="12" md="6" class="my-4   text-center"> 
          <svg width="100" height="100" class="checklist-complete">
            <circle fill="#f8c617" stroke="none" stroke-width="10" cx="50" cy="50" r="46.5" class="circle" stroke-linecap="round"/>
            <polyline fill="none" stroke="#fff" stroke-width="6" points="22,53.5 43,71 76,33" stroke-linecap="round" stroke-linejoin="round" class="tick" />
          </svg>
        </b-col>
        <b-col sm="12" md="9" class="my-4   text-center"> 
          <h1>{{ $t('Hooray your card request has been received!') }}</h1>
          <div class="mt-3 mb-4">
            {{ $t('Our admin team will review the submission request.') }}<br>
            {{ $t('Thank you for your patience!') }}
          </div>
          <button @click="onHideModal" class="btn btn-orange">{{ $t("Back to Dashboard") }}</button>
        </b-col>
      </b-row>  
    </b-modal>

    <LoaderComponent v-if="isLoading"></LoaderComponent>
  </div>
</template>


<script>
  import LoaderComponent from "@/components/LoaderComponent";
  import stepContainer from "@/components/CardManagement/stepContainer";
  import deliveryAddress from '@/components/CardManagement/deliveryAddress';
  import choosenCard from '@/components/CardManagement/choosenCard.vue';
  import confetti from "@/assets/js/confetti.js";
  import Common from '@/services/Common';

  var count = 200;
  var defaults = {
    origin: { x: .5, y:.6 }
  };

  function fire(particleRatio, opts) {
    confetti({
      ...defaults,
      ...opts,
      particleCount: Math.floor(count * particleRatio)
    });
  }

  export default {
    name: 'card-management',
    data() {
      return {
        publicPath :process.env.BASE_URL!='/'?process.env.BASE_URL:'',
        stepList:["Choose Card Product","Fill in Details", "Payment"],
        data:{},
        isLoading : false,
        haveFee:false,
        embossed_name:'',
        currency:'',
        card_type:'',
        isSubmit:false,
        isDisabled:false,
        user_card_currency:[],
        error:{
          embossed_name:'',
          currency:''
        }
      }
    },
    components: {
      LoaderComponent,
      stepContainer,
      deliveryAddress,
      choosenCard
    },
    methods:{
      onChange(name){
        this.error[name]="";
        this.$refs['delivery-address'].isDisabled = false;
        this.isDisabled = false;
        if(name=="currency" && this.user_card_currency.includes(this.currency)){
          this.$refs['delivery-address'].isDisabled = true;
          this.isDisabled = true;
          this.error['currency']="Your card type & currency request has reached maximum limit";
        }

        if(name=="currency" && this.currency){
          let image = this.publicPath+"/img/rcp/card/background-7.png";
          if(this.currency == "HKD"){
            image = this.publicPath+"/img/rcp/card/Card_HKD.png";
          }
          this.$refs['choosenCard'].changeImage(image);
        }
      },
      EmbossedNameCondition(evt) {
        var inputValue = evt.key;
        var isAlphabetic = /^[a-zA-Z]$/.test(inputValue);
        var isBackspace = evt.key === 'Backspace';
        var isSpace = evt.key === ' ';

        if (!isAlphabetic && !isBackspace && !isSpace) {
          evt.preventDefault();
        }
      },
      onHideModal(){
        this.$router.push({ name: 'card-management'});
      },
      showModal(){
        this.$bvModal.show('complete-card-management');
        setTimeout(function(){
          fire(0.25, {
            spread: 26,
            startVelocity: 55,
          });
          fire(0.2, {
            spread: 60,
          });
          fire(0.35, {
            spread: 100,
            decay: 0.91,
            scalar: 0.8
          });
          fire(0.1, {
            spread: 120,
            startVelocity: 25,
            decay: 0.92,
            scalar: 1.2
          });
          fire(0.1, {
            spread: 120,
            startVelocity: 45,
          });
        },500);
      },
      submitRequest(params){
        Common.card_req_new({
          currency:params.currency,
          card_type:params.card_type,
          embossed_name:params.embossed_name,
          country_code:params.country_code,
          state_code:params.state_code,
          city_name:params.city_name,
          postal_code:params.postal_code,
          address:params.address,
          provider_id:params.provider_id
        },null).then(response=>{
          if(response.status == 200){
            this.isSubmit = false;
            this.showModal();
          }
        }).catch(err => {
          this.isSubmit = false;
          this.checkError(err);
        });
      },
      setStep(shipping_fee){
        if(parseFloat(this.data.card_fee)>0 || parseFloat(shipping_fee)>0){
          this.haveFee = true;
        }
        else{
          this.haveFee = false;
        }
        console.log("set ulang");
        console.log(this.haveFee);
      },
      nextStep(){
        let isOk = true;

        let add_params = {};
        if(this.data && this.data.arrival_duration>0){
          add_params = this.$refs['delivery-address'].data;
          Object.keys(add_params).forEach((key) => {
            if(!add_params[key] && key!="shipping_fee"){
              isOk = false;
              this.$refs['delivery-address'].error[key] = "This field can not blank";
            }
          });
        }

        if(!this.embossed_name){
          isOk = false;
          this.error.embossed_name = "This field can not blank";
        }
        if(!this.currency){
          isOk = false;
          this.error.currency = "This field can not blank";
        }

        if(isOk){
          Object.keys(this.error).forEach((key) => {
            if(this.error[key]){
              isOk = false;
            }
          })
        }
        

        add_params['embossed_name']=this.embossed_name.toLocaleUpperCase();
        add_params['currency']=this.currency;
        add_params['card_type']=this.card_type;
        add_params['card_fee']=this.data.card_fee;
        add_params['fee']=this.data.fee;
        add_params['card_fee_currency']=this.data.currency;
        add_params['image']=this.data.image;
        add_params['name']=this.data.name;
        add_params['provider_id']=this.data.provider_id;

        if(isOk){
          if(this.haveFee){
            this.$router.push({ name: 'payment',params: add_params });
          }
          else if(this.isSubmit == false){
            this.isSubmit = true;
            this.submitRequest(add_params);
          }
          
        }
      },
      getCardData(){
        Common.card_unavailable().then(response => {
          this.isLoading = false;
          if(response.status==200){
            console.log(response.data);
            this.user_card_currency=response.data;
          }
        }).catch(err => {
          this.isLoading = false;
          this.checkError(err);
        });
      },
      checkError(err){ 
        try{
          const response = err.response;
          if(response.status == 400){
            let err_msg = [];
            Object.keys(response.data.data).forEach((key) => {
              err_msg.push(response.data.data[key][0]);
            });

            this.$swal({
              icon: 'error',
              text: err_msg.join(", ")
            });
          }         
          else if(response.status == 401 && response.data.name == "Unauthorized"){
                  localStorage.removeItem("token");
                  localStorage.removeItem("member");
                  localStorage.removeItem("isFirstTime");
                  this.$router.push({ 
                    path: '/login', 
                  });
                }
          else{
            var msg = (response.data)?response.data.message:err.message;
            this.$notify({
              type: 'warn',
              text: msg
            })
          }
        }catch(e){
          console.log(err);
        }
      }
    },
    mounted(){
      this.data = this.$route.params.data;

      if(!this.data){
        this.$router.push({ name: 'order-card'});
      }
      else{
        this.isLoading = true;
        this.card_type = this.data.type.toLowerCase();
        this.haveFee = (this.data.card_fee>0)?true:false;
        this.getCardData();
      }
    },
  };
</script>


